import { atom, createStore } from 'jotai';
import { ImageTargetSwitcher } from '../image-target-switcher';
import { IArtwork } from '../../types';

export const imageTargetStore = createStore();

export const imageTargetAtom = atom<IArtwork | undefined>(undefined);
export const artworkLoadingAtom = atom<boolean>(false);

const video = document.getElementById('ej-video') as HTMLVideoElement;
export const imageTargetVideo = atom<HTMLVideoElement>(video);

const audio = document.getElementById('ejx-audio') as HTMLAudioElement;
export const imageTargetAudio = atom<HTMLAudioElement>(audio);

// const imageTargetSwitcher = new ImageTargetSwitcher();

const unsub = imageTargetStore.sub(imageTargetAtom, () => {
    // console.log(
    //     'imageTargetAtom value is changed to',
    //     imageTargetStore.get(imageTargetAtom),
    // );
    const image = imageTargetStore.get(imageTargetAtom);
    if (image) {
        // imageTargetSwitcher.setTargetId = image.targetName.slice(-2);
        // imageTargetSwitcher.handleMarkerSwitch();
    }
});

export enum ImageTargetView {
    ONBOARDING,
    SCANNING,
    LOADING,
    VIEWING,
}
export const imageTargetViewAtom = atom<ImageTargetView>(
    ImageTargetView.ONBOARDING,
);
